import { Star } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';

const reviews = [
  {
    name: 'Sarah M.',
    location: 'Park Slope, Brooklyn',
    rating: 5,
    text: 'Absolutely stunning frameless shower door. The team was professional, on-time, and the installation was flawless. Highly recommend!',
  },
  {
    name: 'David L.',
    location: 'Upper West Side',
    rating: 5,
    text: 'NY Glass installed mirrors in our home gym. Perfect alignment, zero visible seams. They really know their craft.',
  },
  {
    name: 'Jennifer K.',
    location: 'Tribeca',
    rating: 5,
    text: 'Custom glass railing for our loft stairs looks incredible. Modern, minimal, and exactly what we wanted. Great experience from quote to install.',
  },
  {
    name: 'Michael R.',
    location: 'Astoria, Queens',
    rating: 5,
    text: 'Fast response for our storefront glass replacement. Same-week turnaround. Professional crew and fair pricing.',
  },
  {
    name: 'Lisa T.',
    location: 'Chelsea',
    rating: 5,
    text: 'Custom table top came out perfectly. Low-iron glass with beveled edge is exactly what we needed. Will definitely use again.',
  },
];

export function ReviewCarousel() {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-semibold mb-4">What Our Customers Say</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Trusted across all NYC boroughs
          </p>
        </div>

        <div className="max-w-5xl mx-auto px-12">
          <Carousel
            opts={{
              align: 'start',
              loop: true,
            }}
          >
            <CarouselContent>
              {reviews.map((review, index) => (
                <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                  <div className="h-full bg-white border border-border rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
                    {/* Stars */}
                    <div className="flex gap-1 mb-4">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                      ))}
                    </div>

                    {/* Review text */}
                    <p className="text-sm text-muted-foreground mb-4 line-clamp-4">
                      "{review.text}"
                    </p>

                    {/* Author */}
                    <div className="flex items-center gap-3 pt-4 border-t border-border">
                      <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                        <span className="text-sm font-medium text-primary">
                          {review.name
                            .split(' ')
                            .map((n) => n[0])
                            .join('')}
                        </span>
                      </div>
                      <div>
                        <p className="text-sm">{review.name}</p>
                        <p className="text-xs text-muted-foreground">{review.location}</p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
          </Carousel>
        </div>
      </div>
    </section>
  );
}
